<template>
    <section class="attribute-filter-segment">
        <header class="attribute-filter-segment__header">
            <div class="attribute-filter-segment__title">
                {{ segmentLabel }}
            </div>
            <v-btn
                v-if="showRemoveSegment"
                :disabled="isReadOnly"
                density="compact"
                elevation="0"
                variant="text"
                color="primary"
                @click="$emit('remove-segment', segmentIndex)"
            >
                {{ $tkey('removeGroup') }}
            </v-btn>
        </header>

        <v-col
            v-for="(attributeRow, attributeRowIndex) in segment.rows"
            :key="attributeRow.key"
            cols="12"
            class="pa-0"
        >
            <attribute-filter
                :key="`Filter::${attributeRow.key}`"
                :attribute-row-index="attributeRowIndex"
                :attribute-scope="segment.rows"
                :available-attribute-keys="availableAttributeKeysByRowKey[attributeRow.key] || []"
                :available-values="availableValuesByRowKey[attributeRow.key] || []"
                :validate-attribute-select="segment.rows.length > 1"
                @remove-attribute-row="onRemoveAttributeRow"
                @products-number-updated="$emit('products-number-updated', { markDirty: true })"
            />
            <v-divider :key="`Divider::${attributeRow.key}`" class="my-2" />
        </v-col>

        <v-btn
            :disabled="addConditionDisabled"
            density="compact"
            elevation="0"
            variant="text"
            color="primary"
            prepend-icon="custom:add_box"
            @click="$emit('add-condition', segmentIndex)"
        >
            {{ $tkey('addCondition') }}
        </v-btn>
    </section>
</template>

<script>
export default {
    localizationKey: 'planning.promotionsViewer.attributeScopePromotion.attributeFilterSegment',
    props: {
        segment: {
            type: Object,
            required: true,
        },
        segmentIndex: {
            type: Number,
            required: true,
        },
        segmentCount: {
            type: Number,
            required: true,
        },
        availableAttributeKeysByRowKey: {
            type: Object,
            default: () => ({}),
        },
        availableValuesByRowKey: {
            type: Object,
            default: () => ({}),
        },
        addConditionDisabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['add-condition', 'remove-condition', 'remove-segment', 'products-number-updated'],
    computed: {
        segmentLabel() {
            return (
                this.segment.label || this.$tkey('productGroup', { index: this.segmentIndex + 1 })
            );
        },
        showRemoveSegment() {
            return this.segmentCount > 1;
        },
    },
    methods: {
        onRemoveAttributeRow(event) {
            this.$emit('remove-condition', {
                ...event,
                segmentIndex: this.segmentIndex,
            });
        },
    },
};
</script>

<style scoped lang="scss">
@import '@style/base/_variables.scss';

.attribute-filter-segment {
    padding: 1rem 0;

    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: 3.2rem;
        margin-bottom: 0.8rem;
    }

    &__title {
        color: $promo-text-colour-2;
        font-size: 1.25rem;
        font-weight: 700;
    }
}
</style>
